<template>
  <el-group-title :title="title">
    <template slot="groupTitle">
      <el-form
    :label-width="labelWidth"
    class="el-form ccui-form dic-ccui-form-biserial"
    style="margin-left: 75px"
  >
    <el-row>
      <el-col
        v-for="(item, index) in fieldList"
        :key="item.fieldName + index"
        :span="item.displaynone ? 0 :24"
      >
        <el-form-item :label="`${item.label}`">
          <template>
            <div
              class="ellipsis-3"
              :title="dataInfo[item.fieldName]"
              v-if="item.slot === 'regCapl'"
            >
              {{
                dataInfo[item.fieldName] === ""
                  ? ""
                  : dataInfo[item.fieldName] % 1 === 0
                  ? dataInfo[item.fieldName] + ".00"
                  : dataInfo[item.fieldName]
              }}
            </div>
            <div
              class="ellipsis-3"
              :title="dataInfo[item.fieldName]"
              v-else-if="item.slot === 'factCapl'"
            >
              {{
                dataInfo[item.fieldName] === ""
                  ? ""
                  : dataInfo[item.fieldName] % 1 === 0
                  ? dataInfo[item.fieldName] + ".00"
                  : dataInfo[item.fieldName]
              }}
            </div>
            <div class="ellipsis-3" :title="dataInfo[item.fieldName]" v-else>
              {{ dataInfo[item.fieldName] }}
            </div>
          </template>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
    </template>
  </el-group-title>
</template>

<script>
export default {
  name: "basicInfo",
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    },
    fieldList: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    labelWidth: {
      type: String,
      default: "163px"
    }
  }
};
</script>

<style scoped lang="scss">
  /deep/ .el-form-item .el-form-item__content .ellipsis-3 {
    margin-left: 6px;
  }
</style>
